var _circle, _circle2, _g, _path, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E6E4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2066_39261",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1696F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2066_39261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.953 16.9722C16.953 16.9722 15.9565 17.8026 15.7074 20.0447C15.5413 21.7056 16.704 34.9096 17.6174 35.9061C20.1087 38.8126 23.1813 37.5669 24.427 38.0652L25.5896 37.0687C25.5896 37.0687 21.5205 34.0791 21.2714 33.0826C20.0257 29.3456 20.7731 18.3839 16.953 16.9722Z",
    fill: "#8D07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2057 6.25956C16.2057 6.25956 16.2887 3.85129 13.133 3.35303C9.97736 2.85477 9.06388 3.6021 8.56562 4.43254C8.06735 5.26298 6.98783 8.58481 7.15391 9.91351C7.23696 11.2422 10.8909 12.82 10.8079 13.6505C10.6418 14.3979 16.2057 6.25956 16.2057 6.25956Z",
    fill: "#4E20D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57552 40.7224C6.23987 41.2207 7.48557 41.8851 9.56166 41.9681C13.2986 42.1342 17.866 41.6359 18.7795 40.8055C19.0286 40.5563 19.1117 40.2241 19.1947 39.7259C19.2778 38.3141 18.6133 35.989 18.1981 33.9959C17.866 32.7503 17.6999 31.6707 17.866 31.0894C18.3643 29.4285 19.9421 25.9407 20.0252 24.8611C20.1912 23.6985 18.7794 17.6362 16.9525 16.8888C15.0425 16.1414 7.90078 16.8888 7.90078 16.8888C5.0773 17.4701 4.99423 23.4494 5.90771 28.5981C5.90771 28.7642 5.99074 28.8472 5.99074 29.0133C6.98726 34.2451 3.66551 39.4768 5.57552 40.7224Z",
    fill: "#8D07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8791 18.0527C14.7961 18.3849 13.9656 18.8832 11.9726 18.3849C10.1456 17.8867 9.89648 17.3053 9.89648 16.8901C9.89648 16.3918 10.7269 15.8106 10.7269 12.9041L10.9761 12.9871L14.7131 13.7345C14.7131 13.7345 14.63 14.8971 14.63 15.9766C14.63 16.8901 14.9622 17.5545 14.8791 18.0527Z",
    fill: "#CC50B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7145 13.7337C14.7145 13.7337 14.6315 14.8963 14.6315 15.9759C12.5554 15.8928 11.4758 13.9829 10.9775 12.9863L14.7145 13.7337Z",
    fill: "#9B3689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3759 14.814C15.3759 14.814 10.4763 14.8971 10.4763 11.8244C10.4763 8.75181 9.81194 6.6757 12.9676 6.50961C16.1233 6.34352 16.7045 7.50615 16.9536 8.50268C17.2028 9.49921 16.7046 14.6479 15.3759 14.814Z",
    fill: "#CC50B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2098 6.42569C15.2098 6.42569 13.8811 9.99658 11.805 10.5779C9.72889 11.0761 8.81543 10.5779 8.81543 10.5779C8.81543 10.5779 10.3932 9.33227 10.7254 7.09008C10.7254 7.00704 14.2132 4.68177 15.2098 6.42569Z",
    fill: "#4E20D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.877 6.67436C14.877 6.67436 15.8735 7.50481 16.1226 8.25221C16.3717 8.9996 16.4548 10.6604 16.953 10.5774C16.953 10.5774 17.9496 8.16912 16.787 6.75738C15.6244 5.34564 14.877 6.67436 14.877 6.67436Z",
    fill: "#4E20D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90157 16.9716C7.90157 16.9716 5.07802 17.2207 4.82889 19.4629C4.6628 21.1238 3.41716 33.1651 4.33065 34.2446C6.82196 37.1512 15.1263 37.8156 16.372 38.2308L16.7042 36.819C16.7042 36.819 7.81851 32.3346 7.98459 31.3381C8.06764 30.3416 10.559 16.5564 7.90157 16.9716Z",
    fill: "#8D07F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0623 4.59826C10.0623 4.59826 10.2284 3.35258 8.4845 3.02041C6.74058 2.68823 6.65751 6.50829 6.49143 7.42177C6.32534 8.33525 6.74062 8.91649 7.48801 8.91649C8.15236 8.91649 10.0623 4.59826 10.0623 4.59826Z",
    fill: "#4E20D0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L3.69829 1.20381C3.87563 2.28049 4.71951 3.12437 5.79619 3.30171L7 3.5L5.79619 3.69829C4.71951 3.87563 3.87563 4.71951 3.69829 5.79619L3.5 7L3.30171 5.79619C3.12437 4.71951 2.28049 3.87563 1.20381 3.69829L0 3.5L1.20381 3.30171C2.28049 3.12437 3.12437 2.28049 3.30171 1.20381L3.5 0Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.999,
    cy: 2,
    r: 1,
    fill: "#4E20D0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.935bf7fb.svg";
export { ForwardRef as ReactComponent };